(function () {
  const initProductAccordion = () => {
    $(".about__accordion-toggle").click(function () {
      if (!$(this).hasClass("active")) {
        $(this).addClass("active");
        $(this)
          .siblings(".about__accordion-description")
          .eq($(this).index())
          .stop()
          .slideDown(300);
      } else {
        $(this).removeClass("active");
        $(this).siblings(".about__accordion-description").stop().slideUp(300);
      }
    });
  };

  const initZoomImage = () => {
    const imagesWrapper = document.querySelector(
      ".product-media-modal__content"
    );
    const images = imagesWrapper.querySelectorAll(".js-image-zoom");

    images.forEach((el) => {
      el.addEventListener("click", (e) => {
        imagesWrapper.classList.toggle("zoom");
      });
    });
  };



  const revealPopup = () => {
    const stickyBar = document.querySelector('.product__popup'); // Sticky bar
    const secondSection = document.querySelector('.product-section + section'); // Second section
    const footer = document.querySelector('footer'); // Footer

    // Check if the required elements exist
    if (!stickyBar || !secondSection || !footer) {
      console.error('Required elements not found!');
      return;
    }

    const getOffset = (element) => {
      const rect = element.getBoundingClientRect();
      return rect.top + window.scrollY;
    };

    const secondSectionMid = getOffset(secondSection);
    const footerTop = getOffset(footer);

    const handleScroll = () => {
      const scrollPosition = window.scrollY + window.innerHeight;
      const activeOffset = window.scrollY > secondSectionMid && scrollPosition < footerTop;

      stickyBar.classList[activeOffset ? "add" : "remove"]('active');
    };

    // Initial check in case the user starts in the middle of the page
    handleScroll();
  };

  const initRangePicker = (slider) => {
    if (!slider || slider.dataset.rangePickerInitialized === "true") return;
    slider.dataset.rangePickerInitialized = "true";

    const wrapperContext = slider.dataset.wrapperContext || "";
    const wrapper = slider.closest(".variant-range-picker");
    if (!wrapper) return;

    const valueDisplay = wrapper.querySelector("[data-range-picker-value]");
    const datalist = wrapper.querySelector("[data-range-picker-datalist]");
    const pickerWrapper = wrapper.parentElement;
    const allRadioInputs = Array.from(
      pickerWrapper.querySelectorAll("[data-range-radio]")
    );
    const radioInputs = allRadioInputs.filter((radio) => {
      const idSuffix = wrapperContext ? `-${wrapperContext}` : "";
      return radio.id.endsWith(`-range${idSuffix}`);
    });

    if (!valueDisplay || !datalist || radioInputs.length === 0) return;

    const options = Array.from(datalist.querySelectorAll("option"));
    if (options.length !== radioInputs.length) return;

    let isDragging = false;
    let animationFrameId = null;
    let debounceTimer = null;

    const cleanup = () => {
      if (animationFrameId) cancelAnimationFrame(animationFrameId);
      if (debounceTimer) clearTimeout(debounceTimer);
      isDragging = false;
    };

    const updateValuePosition = () => {
      const min = parseFloat(slider.min);
      const max = parseFloat(slider.max);
      const val = parseFloat(slider.value);
      if (max === min) return;

      const percentage = ((val - min) / (max - min)) * 100;
      const sliderRect = slider.getBoundingClientRect();
      const thumbWidth = 8;
      const halfThumb = thumbWidth / 2;
      const availableWidth = sliderRect.width - thumbWidth;
      const thumbPosition = (percentage / 100) * availableWidth + halfThumb;

      valueDisplay.style.left = `${thumbPosition}px`;
      slider.style.setProperty("--value", `${percentage}%`);
    };

    const updateUI = (index) => {
      if (index < 0 || index >= options.length) return;
      valueDisplay.textContent = options[index].dataset.price;
      updateValuePosition();
    };

    const updateVariant = (index) => {
      if (index < 0 || index >= options.length) return;
      updateUI(index);
      radioInputs.forEach((radio, i) => {
        radio.checked = i === index;
      });
      const checkedRadio = radioInputs[index];
      if (checkedRadio) {
        checkedRadio.dispatchEvent(new Event("change", { bubbles: true }));
      }
    };

    const handleSliderUI = () => updateUI(parseInt(slider.value, 10));
    const handleSliderVariant = () => updateVariant(parseInt(slider.value, 10));

    const scheduleVariantUpdate = () => {
      if (debounceTimer) clearTimeout(debounceTimer);
      debounceTimer = setTimeout(handleSliderVariant, 100);
    };

    const scheduleUIUpdate = () => {
      if (animationFrameId) cancelAnimationFrame(animationFrameId);
      animationFrameId = requestAnimationFrame(handleSliderUI);
    };

    const handleInteraction = () => {
      scheduleUIUpdate();
      scheduleVariantUpdate();
    };

    const handleInteractionEnd = () => {
      cleanup();
      handleSliderVariant();
    };

    const hasPointerEvents = "PointerEvent" in window;
    if (hasPointerEvents) {
      slider.addEventListener("pointerdown", () => {
        isDragging = true;
      });
      slider.addEventListener("pointermove", () => {
        if (isDragging) handleInteraction();
      });
      slider.addEventListener("pointerup", handleInteractionEnd);
      slider.addEventListener("pointercancel", handleInteractionEnd);
    } else {
      slider.addEventListener("touchstart", () => {
        isDragging = true;
      });
      slider.addEventListener("touchmove", () => {
        if (isDragging) handleInteraction();
      });
      slider.addEventListener("touchend", handleInteractionEnd);
      slider.addEventListener("touchcancel", handleInteractionEnd);

      slider.addEventListener("mousedown", () => {
        isDragging = true;
      });
      slider.addEventListener("mousemove", () => {
        if (isDragging) handleInteraction();
      });
      slider.addEventListener("mouseup", handleInteractionEnd);
    }

    slider.addEventListener("input", handleInteraction);
    slider.addEventListener("change", () => {
      cleanup();
      handleSliderVariant();
    });

    const visibilityHandler = () => {
      if (document.hidden) cleanup();
    };
    const blurHandler = () => cleanup();

    document.addEventListener("visibilitychange", visibilityHandler);
    window.addEventListener("blur", blurHandler);

    const currentIndex = parseInt(slider.value, 10);
    updateUI(currentIndex);
    radioInputs.forEach((radio, i) => {
      radio.checked = i === currentIndex;
    });

    slider._updateValuePosition = updateValuePosition;
    slider._cleanup = cleanup;
  };

  const initRangePickers = () => {
    document
      .querySelectorAll("[data-range-picker-slider]")
      .forEach((slider) => initRangePicker(slider));

    if (window.__rangePickerGlobalHandlersAttached) return;
    window.__rangePickerGlobalHandlersAttached = true;

    let globalResizeTimeout;

    const updateAllPositions = () => {
      document.querySelectorAll("[data-range-picker-slider]").forEach((slider) => {
        if (slider._updateValuePosition) slider._updateValuePosition();
      });
    };

    const cleanupAllPickers = () => {
      document.querySelectorAll("[data-range-picker-slider]").forEach((slider) => {
        if (slider._cleanup) slider._cleanup();
      });
    };

    window.addEventListener("resize", () => {
      cleanupAllPickers();
      if (globalResizeTimeout) clearTimeout(globalResizeTimeout);
      globalResizeTimeout = setTimeout(updateAllPositions, 100);
    });

    window.addEventListener("orientationchange", () => {
      cleanupAllPickers();
      setTimeout(updateAllPositions, 150);
    });
  };

  document.addEventListener('scroll', () => revealPopup());


  document.addEventListener("shopify:section:load", function () {
    initProductAccordion();
    initZoomImage();
    revealPopup();
    initRangePickers();
  });

  initProductAccordion();
  initZoomImage();
  revealPopup();
  initRangePickers();
})();

class FloatedForm extends HTMLElement {
  constructor() {
    super();
    this.renderForm();
  }

  renderForm() {
    fetch(this.getAttribute("data-product-url"))
      .then((response) => response.text())
      .then((responseText) => {
        const responseHTML = new DOMParser().parseFromString(
          responseText,
          "text/html"
        );
        this.productElement = responseHTML.querySelector(
          'div[id^="ProductInfo-"]'
        );

        this.preventDuplicatedIDs();
        this.removeDOMElements();
        this.setInnerHTML(this, this.productElement.innerHTML);

        if (window.Shopify && Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }

        if (window.ProductModel) window.ProductModel.loadShopifyXR();

        this.showMoreFields();

        // Re-initialize master input sync for floated form after content is loaded
        // Use setTimeout to ensure custom element is fully initialized
        console.log('[FloatedForm] Scheduling re-initialization of master input sync');
        setTimeout(() => {
          const variantRadios = this.querySelector('variant-radios');
          console.log('[FloatedForm] Re-initialization timeout fired:', {
            found: !!variantRadios,
            hasMethod: variantRadios && !!variantRadios.initMasterInputSync,
            dataSection: variantRadios?.dataset.section,
            dataOriginalSection: variantRadios?.dataset.originalSection
          });

          if (variantRadios && variantRadios.initMasterInputSync) {
            // Reset the flag to allow re-initialization
            console.log('[FloatedForm] Resetting initialization flag and calling initMasterInputSync');
            variantRadios._masterInputSyncInitialized = false;
            variantRadios.initMasterInputSync();
          } else {
            console.warn('[FloatedForm] Could not re-initialize master input sync');
          }
        }, 100);
      })
      .finally(() => {
        const selectDropDown = () => {
          $(".product__popup .product-form__controls--dropdown").each(function () {
            const elListItem = $(this).find(".dropdown-select ul li");
            const elItem = $(this).find(".dropdown-select ul");
            const selectedText = $(this).find(
              ".dropdown-select .select-label"
            );

            selectedText.on("click", function (e) {
              elItem.toggleClass("active");
              if (elItem.hasClass("active")) {
                e.stopPropagation();
                $(document).click(function () {
                  elItem.removeClass("active");
                });
              }
            });

            elListItem.on("click", function () {
              selectedText
                .find("span")
                .text($(this).text())
                .attr("title", $(this).text());
              elItem.removeClass("active");
              document.activeElement.blur();
            });
          });
        };

        selectDropDown();
      });
  }

  setInnerHTML(element, html) {
    element.innerHTML = html;

    // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
    element.querySelectorAll("script").forEach((oldScriptTag) => {
      const newScriptTag = document.createElement("script");
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }

  preventDuplicatedIDs() {
    const sectionId = this.productElement.dataset.section;
    console.log('[FloatedForm] preventDuplicatedIDs called:', { sectionId });

    this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(
      sectionId,
      `floated-${sectionId}`
    );

    // Update name attributes for radio inputs (add -floated suffix)
    const radioInputs = this.productElement.querySelectorAll('input[type="radio"]:not([data-master-input])');
    console.log('[FloatedForm] Found radio inputs to rename:', radioInputs.length);

    radioInputs.forEach((input, index) => {
      const currentName = input.getAttribute('name');
      if (currentName && !currentName.includes('-floated-')) {
        // Remove existing -desktop or -mobile suffix before adding -floated
        const baseName = currentName.replace(/-desktop|-mobile$/g, '');
        const newName = `${baseName}-floated-${sectionId}`;
        input.setAttribute('name', newName);
        if (index < 3) {
          console.log('[FloatedForm] Renamed input:', { oldName: currentName, baseName, newName });
        }
      }
    });

    if (this.productElement.querySelectorAll("variant-selects")) {
      this.productElement
        .querySelectorAll("variant-selects")
        .forEach((radio) => {
          radio.dataset.originalSection = sectionId;
        });
    }

    if (this.productElement.querySelectorAll("variant-radios")) {
      const variantRadios = this.productElement.querySelectorAll("variant-radios");
      console.log('[FloatedForm] Setting originalSection on variant-radios:', variantRadios.length);
      variantRadios.forEach((radio) => {
        radio.dataset.originalSection = sectionId;
        console.log('[FloatedForm] Set originalSection:', {
          originalSection: sectionId,
          dataSection: radio.dataset.section
        });
      });
    }
  }

  removeDOMElements() {
    const text = this.productElement.querySelector(".product__text");
    if (text) text.remove();

    const tags = this.productElement.querySelector(".product__tags");
    if (tags) tags.remove();

    const title = this.productElement.querySelector(".product__title__wrapper");
    if (title) title.remove();

    const badges = this.productElement.querySelector(".product__custom-badges");
    if (badges) badges.remove();

    const price = this.productElement.querySelector(".price-wrapper");
    if (price) price.remove();

    const description = this.productElement.querySelector(
      ".product__description"
    );
    if (description) description.remove();

    const sku = this.productElement.querySelector(".product__sku");
    if (sku) sku.remove();

    const inventory = this.productElement.querySelector(".product__inventory");
    if (inventory) inventory.remove();

    const pickupAvailability = this.productElement.querySelector(
      "pickup-availability"
    );
    if (pickupAvailability) pickupAvailability.remove();

    const customLiquid = this.productElement.querySelector(".custom-liquid");
    if (customLiquid) customLiquid.remove();

    const complementary = this.productElement.querySelector(
      "product-recommendations"
    );
    if (complementary) complementary.remove();

    const shareButtons = this.productElement.querySelector(".share-buttons");
    if (shareButtons) shareButtons.remove();

    const productModal = this.productElement.querySelectorAll(".product-popup");
    productModal.forEach((advantage) => {
      advantage.remove();
    });

    const productForm = this.productElement.querySelector("floated-form");
    if (productForm) productForm.remove();
  }

  showMoreFields() {
    $(".js-show-more").click(function (e) {
      e.preventDefault();
      $(this).siblings("input").removeClass("hidden");
      $(this).siblings("label").removeClass("hidden");
      $(this).remove();
    });
  }
}

customElements.define("floated-form", FloatedForm);
